import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { getAsync, putAsync } from '../../../../components/helper/axiosHelper';
import '../GWAStyles.css';
import { DataNotFound } from '../../../../components/DataNotFound';
import { defaultImage } from '../../../../constants';

const GWAProjectApproval = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { id } = useParams();
  const [campaign, setCampaign] = useState('');
  const [project, setProject] = useState('');
  const [projectID, setProjectID] = useState('');
  const [maProjectNotes, setMAProjectNotes] = useState('');
  const [password, setPassword] = useState('');
  const [projectNotes, setProjectNotes] = useState('');
  const [gwaProjectID, setGwaProjectID] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [gWAServiceID, setGWAServiceID] = useState('');

  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const epUser = localStorage.getItem('apid');
  const token = localStorage.getItem('token');
  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    await getAsync('GWAProject/GetGWAProjectById', {
      id: id,
    })
      .then((response) => {
        setIsLoading(false);
        const result = response?.data[0];
        setProject(isActive ? result?.projectNameAR : result?.projectNameAR);
        setCampaign(result?.campaignName);
        setGWAServiceID(result?.gwaServiceID);

        const projectNameInfo = isActive ? result?.projectNameAR : result?.projectNameAR;

        setProjectID(projectNameInfo);
        setProjectNotes(result?.projectNotes);
        setGwaProjectID(result?.gwaProjectID);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  // Generate a random UUID
  const referrel = uuidv4();

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  const userID = localStorage.getItem('apid');
  var localeDateTime = new Date();

  const bodyApprove = {
    epUserID: parseInt(userID),
    gwaProjectID: gwaProjectID,
    maProjectID: parseInt(userID),
    gWAServiceID,
    userId: epUser,
    maProjectApproveID: 1,
    maProjectDate: localeDateTime,
    maProjectNotes: maProjectNotes,
    referralLink: referrel,
    password: password,
    activeID: 1,
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await putAsync('GWAProject/GWAProjectRegisterApproval/', bodyApprove, { id: id })
      .then((response) => {
        setIsLoading(false);
        if (response?.statusCode === 200) {
          toast.success(`${t('This record has been approved')}`);
          getData();
          navigate('/GWAProjectApprovalList');
        } else {
          toast.error(`${t('Password failed Please try Again')}`);
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const bodyDisapprove = {
    epUserID: parseInt(userID),
    gwaProjectID: gwaProjectID,
    userId: epUser,
    gWAServiceID,
    maProjectID: parseInt(userID),
    maProjectApproveID: 2,
    maProjectDate: localeDateTime,
    maProjectNotes: maProjectNotes,
    referralLink: referrel,
    password: password,
    activeID: 2,
  };

  const handleDisapprove = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await putAsync('GWAProject/GWAProjectRegisterApproval/', bodyDisapprove, { id: id })
      .then((response) => {
        setIsLoading(false);
        if (response?.statusCode === 200) {
          toast.success(`${t('This record has been Disapproved')}`);
          getData();
          navigate('/GWAProjectApprovalList');
        } else {
          toast.error(t('Something went wrong, Please try again!'));
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  return (
    <>
      <div className="container-fluid ">
        <div className="row justify-center py-5 mt-3">
          <div className="col-xl-11">
            <form>
              <div className="shadow-md  rounded-md ">
                <div className="card-header text-center">
                  <h1 className="font-bold sm:text-2xl p-2 text-xl text-customgreen">
                    {t('Goodwill Ambassador Project Registration Approval')}
                  </h1>
                </div>
                {isLoading ? (
                  <LoadingAnimation />
                ) : (
                  <>
                    <div className="card-body md:p-10">
                      <div className="row ">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>{t('Campaign')}</label>
                            <input
                              value={campaign}
                              type="text"
                              style={{ cursor: 'no-drop' }}
                              disabled
                              className="border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>{t('Project')}</label>
                            <input
                              value={project}
                              type="text"
                              disabled
                              style={{ cursor: 'no-drop' }}
                              className="border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                            />
                          </div>
                        </div>

                        <div className="col-lg-11 flex justify-center pt-5">
                          <Card
                            style={{
                              width: '18rem',
                              cursor: 'no-drop',
                            }}
                            className="shadow p-3 mb-5 bg-white rounded-3xl "
                          >
                            <Card.Body>
                              <Card.Title className="capitalize text-customgreen text-center">{projectID}</Card.Title>
                              {/* <Card.Text>{projectNotes}</Card.Text> */}
                            </Card.Body>
                            <Card.Img variant="top" src={`data:image/jpeg;base64,${defaultImage}`} />

                            <button
                              className="text-white bg-customgreen
                              mt-3
                       hover:bg-hovergreen focus:outline-none focus:ring-4
                        focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
                              disabled
                            >
                              {t('Selected')}
                            </button>
                          </Card>
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>{t('Project Notes')}</label>
                            <textarea
                              value={projectNotes}
                              style={{ cursor: 'no-drop' }}
                              type="text"
                              disabled
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label>
                              {t('Managed Project Notes')} <span className="errmsg">*</span>
                            </label>
                            <textarea
                              style={{ height: '100px' }}
                              value={maProjectNotes}
                              onChange={(e) => setMAProjectNotes(e.target.value)}
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                              minLength="1"
                              maxLength="200"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>
                              {t('Password')} <span className="errmsg">*</span>
                            </label>
                            <input
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              type="password"
                              className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                              minLength="1"
                              maxLength="50"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer flex flex-wrap justify-center gap-2 items-center py-5">
                      <button
                        type="submit"
                        onClick={handleApprove}
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      >
                        {t('Approve')}
                      </button>

                      <button
                        type="submit"
                        onClick={handleDisapprove}
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      >
                        {t('Disapprove')}
                      </button>

                      <Link
                        to={'/GWAProjectApprovalList'}
                        className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                      >
                        {t('Back')}
                      </Link>
                    </div>
                  </>
                )}
                {datanotfound && <DataNotFound />}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default GWAProjectApproval;
